// Mutations
export const SET_PROJECT_NAME = 'SET_PROJECT_NAME';
export const SET_PROJECT_CUSTOMER = 'SET_PROJECT_CUSTOMER';
export const SET_PROJECT_STUDENT = 'SET_PROJECT_STUDENT';
export const SET_PROJECT_CUSTOMER_STATUS = 'SET_PROJECT_CUSTOMER_STATUS';
export const SET_PROJECT_SKILL = 'SET_PROJECT_SKILL';
export const SET_PROJECT_MESSAGE = 'SET_PROJECT_MESSAGE';
export const SET_PROJECT_STEP = 'SET_PROJECT_STEP';
export const RESET_PROJECT = 'RESET_PROJECT';

// Login states
export const LOGGED_IN = 'LOGGED_IN';
export const NEW_REGISTRATION = 'NEW_REGISTRATION';

// Steps
export const STEP_ONE = 'STEP_ONE';
export const STEP_TWO = 'STEP_TWO';
export const STEP_THREE = 'STEP_THREE';



// WEBPACK FOOTER //
// ./src/taskflex/students/store/contactForm/_types.js